/**
 * @file Photo related queries.
 */
import gql from 'graphql-tag';

import { PhotoUrlTypeFields } from '../fragments/album';
import { CommentDetails } from '../fragments/comments';
import {
  AccountFileReactionDetails,
  GroupedReactionsDetails,
  ReactionAccountDetails,
} from '../fragments/reactions';

export const PhotoDownloadURL = gql`
  query getPhotoDownloadUrl($photos: [PhotoDownloadUrlsItem]!) {
    photoDownloadUrls(photos: $photos) {
      photo_urls
    }
  }
`;

export const PhotoForStandaloneView = gql`
  query photoForStandaloneView($id: RecordID!) {
    photo(id: $id) {
      id
      thumbnail_urls {
        ...PhotoUrlTypeFields
      }
    }
  }
  ${PhotoUrlTypeFields}
`;

export const PhotoForCommentsAndReactions = gql`
  query photoForCommentsAndReactions(
    $id: RecordID!
    $comments_limit: Int = 100
    $comments_offset: Int = 0
    $account_reactions_limit: Int = 50
    $account_reactions_offset: Int = 0
    $parent_id: RecordID
    $root_only: Boolean
  ) {
    photo(id: $id) {
      id
      is_owner
      is_uploader
      description
      comments(
        slice: { limit: $comments_limit, offset: $comments_offset }
        parent_id: $parent_id
        root_only: $root_only
      ) {
        total
        records {
          id
          ...CommentDetails
        }
      }
      grouped_reactions(slice: { limit: 999 }) {
        total
        records {
          id
          ...GroupedReactionsDetails
        }
      }
      account_file_reaction {
        ...AccountFileReactionDetails
      }
      reactions_accounts(
        slice: {
          limit: $account_reactions_limit
          offset: $account_reactions_offset
        }
      ) {
        total
        records {
          ...ReactionAccountDetails
        }
      }
    }
  }
  ${CommentDetails}
  ${GroupedReactionsDetails}
  ${AccountFileReactionDetails}
  ${ReactionAccountDetails}
`;
